import { render, staticRenderFns } from "./approvalActionBar.vue?vue&type=template&id=4a4d3e5e&scoped=true&"
import script from "./approvalActionBar.vue?vue&type=script&lang=js&"
export * from "./approvalActionBar.vue?vue&type=script&lang=js&"
import style0 from "./approvalActionBar.vue?vue&type=style&index=0&id=4a4d3e5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d3e5e",
  null
  
)

export default component.exports